import * as XLSX from 'xlsx';
import React, { Component } from 'react';
import ImportXSLXFile from 'components/imports/ImportXSLXFile';
import { v4 as uuid } from 'uuid';

/*
 * Handles importing accounts from wb and opening appropriate modal.
 */
export default class ImportAccounts extends Component {
  constructor(props) {
    super(props);
    this.handleWorkbook = this.handleWorkbook.bind(this);
  }

  handleWorkbook(wb) {
    const wsnames = wb.SheetNames;
    const wsdata = wsnames.map((wsname) => {
      return XLSX.utils.sheet_to_json(wb.Sheets[wsname], {
        header: 1,
        blankrows: false,
      });
    });
    this.props.openModal({
      id: uuid(),
      type: 'component',
      componentType: 'ImportAccountsModal',
      data: {
        wsnames,
        wsdata,
      },
    });
  }

  render() {
    return (
      <div style={{ display: 'inline-block' }}>
        <ImportXSLXFile
          id={this.props.id}
          handleWorkbook={this.handleWorkbook}
          label={this.props.label}
        />
      </div>
    );
  }
}
